import { NgModule } from '@angular/core';
//import {NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap'
//import {CdkTableModule} from '@angular/cdk/table';
import { BrowserModule } from '@angular/platform-browser';
import {StInputTextComponent} from './st-input-text/st-input-text.component';
import {RouterModule} from "@angular/router";
import {StButtonComponent} from "./st-button/st-button.component";
import {StButtonCancelComponent} from "./st-button-cancel/st-button-cancel.component";
import {StButtonDeleteAllComponent} from "./st-button-delete-all/st-button-delete-all.component";
import {StButtonEditComponent} from "./st-button-edit/st-button-edit.component";
import {StInputSensitiveTextComponent} from "./st-input-sensitive-text/st-input-sensitive-text.component";
import {StInputTextEmailComponent} from "./st-input-text-email/st-input-text-email.component";
import {StInputTextPhoneComponent} from "./st-input-text-phone/st-input-text-phone.component";
import {StCurrentUserNaviconComponent} from "./st-current-user-navicon/st-current-user-navicon.component";
import {NgbDropdown, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {StHeaderComponent} from "./st-header/st-header.component";
import {AuthService} from "../../services/auth.service";
import {StBreadcrumbsComponent} from "./st-breadcrumbs/st-breadcrumbs.component";
import {StDatePickerComponent} from "./st-date-picker/st-date-picker.component";
import {StButtonFilterComponent} from "./st-button-filter/st-button-filter.component";
import {StDropdownListComponent} from "./st-dropdown-list/st-dropdown-list.component";
import {StUsaDropdownListComponent} from "./st-usa-state-dropdown-list/st-usa-dropdown-list.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AsyncPipe} from "@angular/common";
import {CommonModule} from "@angular/common";
import {StSelectComponent} from "./st-select/st-select.component";
import {StButtonExcelComponent} from "./st-button-excel/st-button-excel.component";
import {StButtonPdfComponent} from "./st-button-pdf/st-button-pdf.component";
import {StTextAreaComponent} from "./st-textarea/st-textarea.component";
import {StSpanComponent} from "./st-span/st-span.component";
import {StHeaderTitleComponent} from "./st-header-title/st-header-title.component";
import {StChipComponent} from "./st-chip/st-chip.component";
import {StButtonSortNumberAscComponent} from "./st-button-sort-number-asc/st-button-sort-number-asc.component";
import {StButtonSortNumberDescComponent} from "./st-button-sort-number-desc/st-button-sort-number-desc.component";
import {StButtonSortTextAscComponent} from "./st-button-sort-text-asc/st-button-sort-text-asc.component";
import {StButtonSortTextDescComponent} from "./st-button-sort-text-desc/st-button-sort-text-desc.component";
import {StChipListComponent} from "./st-chip-list/st-chip-list.component";
import {StInputCurrencyTextComponent} from "./st-input-currency-text/st-input-currency-text.component";
import {StPagination2Component} from "./st-pagination/st-pagination2.component";
import {StSelectShortComponent} from "./st-select-short/st-select-short.component";
import {StHeaderWithSideMenuComponent} from "./st-header-with-side-menu/st-header-with-side-menu.component";
import {StButtonBackToTopComponent} from "./st-button-back-to-top/st-button-back-to-top.component";
import {StAutocompleteKeyLookupComponent} from "./st-autocomplete-key-lookup/st-autocomplete-key-lookup.component";
import {StAutocompleteComponent} from "./st-autocomplete/st-autocomplete.component";
import {StButtonWhiteComponent} from "./st-button-white/st-button-white.component";
import {
  StAutocompleteConsultantKeyLookupComponent
} from "./st-autocomplete-consultant-key-lookup/st-autocomplete-consultant-key-lookup.component";
import {
  StImpersonationFloatingBannerComponent
} from "./st-impersonation-floating-banner/st-impersonation-floating-banner.component";
import {
  StFixedHorizontalNavBarScrollComponent
} from "./st-fixed-horizontal-nav-bar-scroll/st-fixed-horizontal-nav-bar-scroll.component";
import {StBannerComponent} from "./st-banner/st-banner.component";
import {LoggedInPageBaseComponent} from "./logged-in-page-base/logged-in-page-base.component";
import {StFooterComponent} from "./st-footer/st-footer.component";

@NgModule({
  declarations: [
    StAutocompleteComponent,
    StAutocompleteKeyLookupComponent,
    StAutocompleteConsultantKeyLookupComponent,
    StBannerComponent,
    StBreadcrumbsComponent,
    StChipComponent,
    StFooterComponent,
    StInputTextComponent,
    StInputCurrencyTextComponent,
    StInputSensitiveTextComponent,
    StInputTextPhoneComponent,
    StInputTextEmailComponent,
    StButtonBackToTopComponent,
    StButtonComponent,
    StButtonCancelComponent,
    StButtonDeleteAllComponent,
    StButtonEditComponent,
    StButtonSortNumberAscComponent,
    StButtonSortNumberDescComponent,
    StButtonSortTextAscComponent,
    StButtonSortTextDescComponent,
    StButtonWhiteComponent,
    StChipListComponent,
    StCurrentUserNaviconComponent,
    StFixedHorizontalNavBarScrollComponent,
    StHeaderComponent,
    StHeaderWithSideMenuComponent,
    StImpersonationFloatingBannerComponent,
    LoggedInPageBaseComponent,
    StDatePickerComponent,
    StButtonFilterComponent,
    StDropdownListComponent,
    StUsaDropdownListComponent,
    StSelectComponent,
    StSelectShortComponent,
    StButtonExcelComponent,
    StButtonPdfComponent,
    StTextAreaComponent,
    StSpanComponent,
    StHeaderTitleComponent,
    StPagination2Component,
    StAutocompleteConsultantKeyLookupComponent
  ],
  exports: [
    StAutocompleteComponent,
    StAutocompleteKeyLookupComponent,
    StAutocompleteConsultantKeyLookupComponent,
    StBannerComponent,
    StBreadcrumbsComponent,
    StChipComponent,
    StFooterComponent,
    StFixedHorizontalNavBarScrollComponent,
    StInputTextComponent,
    StInputCurrencyTextComponent,
    StInputSensitiveTextComponent,
    StInputTextPhoneComponent,
    StInputTextEmailComponent,
    StButtonBackToTopComponent,
    StButtonComponent,
    StButtonCancelComponent,
    StButtonDeleteAllComponent,
    StButtonEditComponent,
    StButtonSortNumberAscComponent,
    StButtonSortNumberDescComponent,
    StButtonSortTextAscComponent,
    StButtonSortTextDescComponent,
    StButtonWhiteComponent,
    StChipListComponent,
    StCurrentUserNaviconComponent,
    StHeaderComponent,
    StHeaderWithSideMenuComponent,
    LoggedInPageBaseComponent,
    StImpersonationFloatingBannerComponent,
    StDatePickerComponent,
    StButtonFilterComponent,
    StDropdownListComponent,
    StUsaDropdownListComponent,
    StSelectComponent,
    StSelectShortComponent,
    StButtonExcelComponent,
    StButtonPdfComponent,
    StTextAreaComponent,
    StSpanComponent,
    StHeaderTitleComponent,
    StPagination2Component,
    StAutocompleteConsultantKeyLookupComponent
  ],
  imports: [CommonModule,
    RouterModule, NgbDropdown, NgbModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe
  ],
  providers: [AuthService],
  bootstrap: []
})
export class StUiComponentsModule {}
